module.exports = __webpack_public_path__ + "static/media/29ADMSPC7.b6031a95.jpg";